import { request } from 'umi';

export async function getCategories(recipients: string, generation?: string) {
  let version = '';
  if (generation && generation !== 'generation_1.0') {
    version = generation || '';
  }
  return request<API.Category[]>('/api/categories', {
    method: 'GET',
    params: {
      recipients,
      version,
    },
  });
}

export async function getQuestions(client?: string) {
  return request<API.Question[]>('/api/questions', {
    method: 'GET',
    params: {
      client,
    },
  });
}
